import { first /* , isEmpty  */ } from 'lodash'
import {
  synapse,
  ModalActions,
  ScenarioPermissions,
  ScenarioProgressColumn,
  ScenarioPlatformActions
} from '@ublique/platform'
//import { saveAs } from 'file-saver'
import { BASE_URL } from 'config'

const { openModal } = ModalActions
const { READ /* , UPDATE */ } = ScenarioPermissions
const { DELETE_SCENARIO, RESET_SCENARIO } = ScenarioPlatformActions
const { PROGRESS, PLAY, OUTPUT, ERROR, LOADING } = ScenarioProgressColumn

const showOptOutput = async ({ data, history }) => {
  const { id } = data
  history.push(`/output/${id}`)
}

/* const makeDownloadOutput =
  (i18n) =>
  async ({ data }) => {
    const { id } = data
    const lang = i18n.language

    const { body, fileName } = await synapse.fetch(
      `${BASE_URL}/reports/_/report/excel`,
      { method: 'POST' },
      {
        planId: null,
        scenarioCode: id,
        zip: true,
        lang
      }
    )
    saveAs(body, fileName)
  }

const consolidateScenario = async ({ data }) => {
  const { id } = data
  const scenarioStatus = 'CONSOLIDATING'

  const outputsBody = {
    scenarioStatus,
    scenarioCode: id
  }

  const body = {
    data: {},
    scenarioManager: { status: scenarioStatus }
  }

  await synapse.fetch(
    `${BASE_URL}/output/${id}`,
    { method: 'PUT' },
    outputsBody
  )

  await synapse.fetch(`${BASE_URL}/scenarios/${id}`, { method: 'PUT' }, body)
} */

const getHypothesis = (configurator) => {
  const hyps = []
  const ids = ['confNomeIpotesiA', 'confNomeIpotesiB', 'confNomeIpotesiC']
  ids.forEach((id) => {
    hyps.push(configurator[id]?.title)
  })
  return hyps
}

const validateScenario = async ({ data }) => {
  const { scenarioInstance, id } = data
  const { body } = await synapse.fetch(
    `${BASE_URL}/instances/${scenarioInstance}/documents?type=configurator`,
    { method: 'GET' }
  )

  const hypotesis = first(body) ? getHypothesis(first(body)) : []

  openModal('validationModal', {
    hypotesis: hypotesis,
    onSave: async (hyp) => {
      const scenarioStatus = 'VALIDATED'

      const body = {
        data: { hypetesis: hyp },
        scenarioManager: { status: scenarioStatus }
      }

      await synapse.fetch(
        `${BASE_URL}/scenarios/${id}`,
        { method: 'PUT' },
        body
      )
    }
  })
}

/* const cancelConsolidate = async ({ data }) => {
  const { id } = data
  const scenarioStatus = 'DONE'

  const outputsBody = {
    scenarioStatus: 'DRAFT',
    scenarioCode: id
  }

  const body = {
    data: {},
    scenarioManager: { status: scenarioStatus }
  }

  await synapse.fetch(
    `${BASE_URL}/output/${id}`,
    { method: 'PUT' },
    outputsBody
  )

  await synapse.fetch(`${BASE_URL}/scenarios/${id}`, { method: 'PUT' }, body)
}

const frozeScenario = async ({ data }) => {
  const { id } = data
  const scenarioStatus = 'FREEZED'

  const outputsBody = {
    scenarioStatus,
    scenarioCode: id
  }

  const body = {
    data: {},
    scenarioManager: { status: scenarioStatus }
  }

  await synapse.fetch(
    `${BASE_URL}/output/${id}`,
    { method: 'PUT' },
    outputsBody
  )

  await synapse.fetch(`${BASE_URL}/scenarios/${id}`, { method: 'PUT' }, body)
}

const sendMail = async ({ data }) => {
  const { id } = data
  await synapse.fetch(`${BASE_URL}/output/${id}/mail`, {
    method: 'POST'
  })
}

const sendSms = ({ data }) => {
  const { id } = data
  synapse.fetch(`${BASE_URL}/output/${id}/sms`, {
    method: 'POST'
  })
} */

export const getTableActions = (t, i18n) => {
  //const downloadOutput = makeDownloadOutput(i18n)
  return {
    WAIT: {
      column: LOADING,
      menuActions: []
    },
    IMPORTING: {
      column: LOADING,
      menuActions: []
    },
    BUILDING: {
      column: PROGRESS,
      menuActions: []
    },
    CLONING: {
      column: PROGRESS,
      menuActions: []
    },
    SAVING: {
      column: PROGRESS,
      menuActions: []
    },
    DELETING: {
      column: PROGRESS,
      menuActions: []
    },
    RUNNING: {
      column: PROGRESS,
      menuActions: []
    },
    CONSOLIDATING: {
      column: PROGRESS,
      menuActions: []
    },
    VALIDATION: {
      column: PROGRESS,
      menuActions: []
    },
    PREPARATION: {
      column: PROGRESS,
      menuActions: []
    },
    READY: {
      column: PLAY,
      menuActions: [
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        },
        {
          title: t('Table.Menu.ValidateScenario'),
          action: validateScenario,
          permission: READ
        }
      ]
    },
    CREATED: {
      column: PLAY,
      menuActions: [
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        }
      ]
    },
    DONE: {
      column: OUTPUT,
      menuActions: [
        {
          title: t('Table.Menu.showOptOutput'),
          action: showOptOutput,
          permission: READ
        },
        {
          title: t('Table.Menu.ValidateScenario'),
          action: validateScenario,
          permission: READ
        },
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        },
        {
          title: t('Table.Menu.resetScenario'),
          action: RESET_SCENARIO
        }
      ]
    },
    VALIDATED: {
      column: OUTPUT,
      menuActions: [
        {
          title: t('Table.Menu.showOptOutput'),
          action: showOptOutput,
          permission: READ
        },
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        },
        {
          title: t('Table.Menu.resetScenario'),
          action: RESET_SCENARIO
        }
      ]
    },
    ERROR: {
      column: ERROR,
      menuActions: [
        {
          title: t('Table.Menu.resetScenario'),
          action: RESET_SCENARIO
        },
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        }
      ]
    },
    CREATE_ERROR: {
      column: ERROR,
      menuActions: [
        {
          title: t('Table.Menu.deleteScenario'),
          action: DELETE_SCENARIO
        }
      ]
    }
  }
}
